import React, { useState, useEffect } from 'react';
import './AnwendungModal.css';

const AnwendungModal = ({ anwendung, prozesse, onSave, onClose }) => {
    const [activeTab, setActiveTab] = useState('basis');
    const [formData, setFormData] = useState({
        // Basisdaten
        anwendung_name: '',
        anwendung_beschreibung: '',
        anwendung_kategorie: '',
        anwendung_verantwortlicher: '',
        gesamtschutzbedarf: '',
        prozess_id: '',
        ist_relevant: true,
        nicht_relevant_begruendung: '',
        // Compliance-Felder - Technische Sicherheit
        ist_schatten_it: false,
        sod_pruefung_aktiv: false,
        vier_augen_prinzip: false,
        patch_management_aktiv: false,
        backup_konzept_vorhanden: false,
        change_management_dokumentiert: false,
        logging_aktiv: false,
        verschluesselung_aktiv: false,
        netzwerksegmentierung_aktiv: false,
        kryptokonzept_vorhanden: false,
        kapazitaetsplanung_vorhanden: false,
        // DORA Compliance
        dora_relevant: false,
        drittdienstleister: '',
        penetration_testing_durchgefuehrt: false,
        letztes_pentest_datum: '',
        threat_intelligence_aktiv: false,
        // DSGVO Compliance
        dsfa_durchgefuehrt: false,
        toms_dokumentiert: false,
        avv_vorhanden: false,
        loeschkonzept_vorhanden: false,
    });

    useEffect(() => {
        if (anwendung) {
            setFormData({
                // Basisdaten
                anwendung_name: anwendung.anwendung_name || '',
                anwendung_beschreibung: anwendung.anwendung_beschreibung || '',
                anwendung_kategorie: anwendung.anwendung_kategorie || '',
                anwendung_verantwortlicher: anwendung.anwendung_verantwortlicher || '',
                gesamtschutzbedarf: anwendung.gesamtschutzbedarf || '',
                prozess_id: anwendung.prozess_id || '',
                ist_relevant: anwendung.ist_relevant !== undefined ? anwendung.ist_relevant : true,
                nicht_relevant_begruendung: anwendung.nicht_relevant_begruendung || '',
                // Compliance-Felder
                ist_schatten_it: anwendung.ist_schatten_it || false,
                sod_pruefung_aktiv: anwendung.sod_pruefung_aktiv || false,
                vier_augen_prinzip: anwendung.vier_augen_prinzip || false,
                patch_management_aktiv: anwendung.patch_management_aktiv || false,
                backup_konzept_vorhanden: anwendung.backup_konzept_vorhanden || false,
                change_management_dokumentiert: anwendung.change_management_dokumentiert || false,
                logging_aktiv: anwendung.logging_aktiv || false,
                verschluesselung_aktiv: anwendung.verschluesselung_aktiv || false,
                netzwerksegmentierung_aktiv: anwendung.netzwerksegmentierung_aktiv || false,
                kryptokonzept_vorhanden: anwendung.kryptokonzept_vorhanden || false,
                kapazitaetsplanung_vorhanden: anwendung.kapazitaetsplanung_vorhanden || false,
                dora_relevant: anwendung.dora_relevant || false,
                drittdienstleister: anwendung.drittdienstleister || '',
                penetration_testing_durchgefuehrt: anwendung.penetration_testing_durchgefuehrt || false,
                letztes_pentest_datum: anwendung.letztes_pentest_datum || '',
                threat_intelligence_aktiv: anwendung.threat_intelligence_aktiv || false,
                dsfa_durchgefuehrt: anwendung.dsfa_durchgefuehrt || false,
                toms_dokumentiert: anwendung.toms_dokumentiert || false,
                avv_vorhanden: anwendung.avv_vorhanden || false,
                loeschkonzept_vorhanden: anwendung.loeschkonzept_vorhanden || false,
            });
        }
    }, [anwendung]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.anwendung_name.trim()) {
            alert('Bitte geben Sie einen Namen ein');
            return;
        }

        if (!formData.ist_relevant && !formData.nicht_relevant_begruendung.trim()) {
            alert('Bitte geben Sie eine Begründung an, warum die Anwendung nicht relevant ist');
            return;
        }

        // Payload vorbereiten - Leere Strings → null
        const payload = {
            ...formData,
            nicht_relevant_begruendung: formData.ist_relevant ? null : formData.nicht_relevant_begruendung,
            // Leere Strings zu null konvertieren
            drittdienstleister: formData.drittdienstleister?.trim() || null,
            letztes_pentest_datum: formData.letztes_pentest_datum || null,
            anwendung_kategorie: formData.anwendung_kategorie?.trim() || null,
        };

        onSave(payload);
    };

    const schutzniveauOptionen = [
        { value: '', label: '- Bitte wählen -' },
        { value: 'gering', label: 'Gering' },
        { value: 'normal', label: 'Normal' },
        { value: 'hoch', label: 'Hoch' },
        { value: 'sehr_hoch', label: 'Sehr Hoch' },
    ];

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content anwendung-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{anwendung ? 'Anwendung bearbeiten' : 'Neue Anwendung'}</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                {/* TAB NAVIGATION */}
                <div className="modal-tabs">
                    <button
                        type="button"
                        className={`tab-button ${activeTab === 'basis' ? 'active' : ''}`}
                        onClick={() => setActiveTab('basis')}
                    >
                        📋 Basisdaten
                    </button>
                    <button
                        type="button"
                        className={`tab-button ${activeTab === 'compliance' ? 'active' : ''}`}
                        onClick={() => setActiveTab('compliance')}
                    >
                        🔒 Compliance
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {/* TAB: BASISDATEN */}
                        {activeTab === 'basis' && (
                            <div className="tab-content">
                                {/* Name */}
                                <div className="form-group">
                                    <label htmlFor="anwendung_name">
                                        Name <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="anwendung_name"
                                        name="anwendung_name"
                                        value={formData.anwendung_name}
                                        onChange={handleChange}
                                        placeholder="z.B. Buchhaltungssoftware SAP"
                                        required
                                    />
                                </div>

                                {/* Beschreibung */}
                                <div className="form-group">
                                    <label htmlFor="anwendung_beschreibung">Beschreibung</label>
                                    <textarea
                                        id="anwendung_beschreibung"
                                        name="anwendung_beschreibung"
                                        value={formData.anwendung_beschreibung}
                                        onChange={handleChange}
                                        placeholder="Kurze Beschreibung der Anwendung"
                                        rows="3"
                                    />
                                </div>

                                {/* Kategorie */}
                                <div className="form-group">
                                    <label htmlFor="anwendung_kategorie">Kategorie</label>
                                    <input
                                        type="text"
                                        id="anwendung_kategorie"
                                        name="anwendung_kategorie"
                                        value={formData.anwendung_kategorie}
                                        onChange={handleChange}
                                        placeholder="z.B. Finanzsoftware, CRM, ERP"
                                    />
                                </div>

                                {/* Verantwortlicher */}
                                <div className="form-group">
                                    <label htmlFor="anwendung_verantwortlicher">Verantwortlicher</label>
                                    <input
                                        type="text"
                                        id="anwendung_verantwortlicher"
                                        name="anwendung_verantwortlicher"
                                        value={formData.anwendung_verantwortlicher}
                                        onChange={handleChange}
                                        placeholder="z.B. Max Mustermann"
                                    />
                                </div>

                                {/* Zugeordneter Prozess */}
                                <div className="form-group">
                                    <label htmlFor="prozess_id">Zugeordneter Prozess (optional)</label>
                                    <select
                                        id="prozess_id"
                                        name="prozess_id"
                                        value={formData.prozess_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">- Kein Prozess -</option>
                                        {prozesse.map(prozess => (
                                            <option key={prozess.prozess_id} value={prozess.prozess_id}>
                                                {prozess.prozess_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Relevanz */}
                                <div className="form-group">
                                    <div className="checkbox-group">
                                        <input
                                            type="checkbox"
                                            id="ist_relevant"
                                            name="ist_relevant"
                                            checked={formData.ist_relevant}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="ist_relevant" className="checkbox-label">
                                            Anwendung ist relevant für die Schutzbedarfsanalyse
                                        </label>
                                    </div>
                                </div>

                                {/* Begründung wenn nicht relevant */}
                                {!formData.ist_relevant && (
                                    <div className="form-group nicht-relevant-section">
                                        <label htmlFor="nicht_relevant_begruendung">
                                            Begründung (Nicht relevant) <span className="required">*</span>
                                        </label>
                                        <textarea
                                            id="nicht_relevant_begruendung"
                                            name="nicht_relevant_begruendung"
                                            value={formData.nicht_relevant_begruendung}
                                            onChange={handleChange}
                                            placeholder="Warum ist diese Anwendung nicht relevant für die Schutzbedarfsanalyse?"
                                            rows="3"
                                            required={!formData.ist_relevant}
                                        />
                                        <small className="form-hint">
                                            Bitte geben Sie eine nachvollziehbare Begründung an, warum diese Anwendung
                                            nicht in die Schutzbedarfsanalyse einbezogen werden muss.
                                        </small>
                                    </div>
                                )}

                                {/* Gesamtschutzbedarf - nur wenn relevant */}
                                {formData.ist_relevant && (
                                    <div className="form-group">
                                        <label htmlFor="gesamtschutzbedarf">Gesamtschutzbedarf</label>
                                        <select
                                            id="gesamtschutzbedarf"
                                            name="gesamtschutzbedarf"
                                            value={formData.gesamtschutzbedarf}
                                            onChange={handleChange}
                                        >
                                            {schutzniveauOptionen.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* TAB: COMPLIANCE */}
                        {activeTab === 'compliance' && (
                            <div className="tab-content">
                                <div className="compliance-section">
                                    <h3 className="section-title">🔐 Technische Sicherheitsmaßnahmen</h3>
                                    <div className="checkbox-grid-two-col">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="patch_management_aktiv"
                                                checked={formData.patch_management_aktiv}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Patch Management aktiv
                                                <small>BAIT, MaRisk AT 7.2</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="backup_konzept_vorhanden"
                                                checked={formData.backup_konzept_vorhanden}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Backup-Konzept vorhanden
                                                <small>MaRisk AT 7.2, BAIT</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="logging_aktiv"
                                                checked={formData.logging_aktiv}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Logging aktiv
                                                <small>BAIT 3.2, BSI OPS.1.1.5</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="verschluesselung_aktiv"
                                                checked={formData.verschluesselung_aktiv}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Verschlüsselung aktiv
                                                <small>BAIT 3.1, DSGVO Art. 32</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="netzwerksegmentierung_aktiv"
                                                checked={formData.netzwerksegmentierung_aktiv}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Netzwerksegmentierung aktiv
                                                <small>BAIT 3.1, BSI NET.1.1</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="change_management_dokumentiert"
                                                checked={formData.change_management_dokumentiert}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Change Management dokumentiert
                                                <small>BAIT, BSI OPS.1.1.3</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="kryptokonzept_vorhanden"
                                                checked={formData.kryptokonzept_vorhanden}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Kryptokonzept vorhanden
                                                <small>BSI CON.1</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="kapazitaetsplanung_vorhanden"
                                                checked={formData.kapazitaetsplanung_vorhanden}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Kapazitätsplanung vorhanden
                                                <small>BAIT 2.2</small>
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div className="compliance-section">
                                    <h3 className="section-title">⚖️ Funktionstrennung & Kontrollen</h3>
                                    <div className="checkbox-grid-two-col">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="sod_pruefung_aktiv"
                                                checked={formData.sod_pruefung_aktiv}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                SoD-Prüfung aktiv
                                                <small>BaFin MaRisk AT 4.4.2</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="vier_augen_prinzip"
                                                checked={formData.vier_augen_prinzip}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Vier-Augen-Prinzip
                                                <small>BaFin MaRisk AT 4.4.2</small>
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div className="compliance-section">
                                    <h3 className="section-title">🛡️ DORA Compliance</h3>
                                    <div className="checkbox-grid-two-col">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="dora_relevant"
                                                checked={formData.dora_relevant}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                DORA-relevant
                                                <small>Anwendung unterliegt DORA</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="penetration_testing_durchgefuehrt"
                                                checked={formData.penetration_testing_durchgefuehrt}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Penetration Testing durchgeführt
                                                <small>DORA Art. 26 (TLPT)</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="threat_intelligence_aktiv"
                                                checked={formData.threat_intelligence_aktiv}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Threat Intelligence aktiv
                                                <small>DORA Art. 7</small>
                                            </span>
                                        </label>
                                    </div>
                                    <br/>
                                    <div className="form-group">
                                        <label htmlFor="drittdienstleister">Drittdienstleister</label>
                                        <input
                                            type="text"
                                            id="drittdienstleister"
                                            name="drittdienstleister"
                                            value={formData.drittdienstleister}
                                            onChange={handleChange}
                                            placeholder="Name des Drittdienstleisters (DORA Art. 28-30)"
                                        />
                                        <small className="form-hint">
                                            Bei DORA-relevanten Anwendungen mit Drittdienstleister erforderlich
                                        </small>
                                    </div>

                                    {formData.penetration_testing_durchgefuehrt && (
                                        <div className="form-group">
                                            <label htmlFor="letztes_pentest_datum">Letztes Pentest-Datum</label>
                                            <input
                                                type="date"
                                                id="letztes_pentest_datum"
                                                name="letztes_pentest_datum"
                                                value={formData.letztes_pentest_datum}
                                                onChange={handleChange}
                                            />
                                            <small className="form-hint">
                                                Pentest älter als 1 Jahr löst GAP aus
                                            </small>
                                        </div>
                                    )}
                                </div>

                                <div className="compliance-section">
                                    <h3 className="section-title">📋 DSGVO Compliance</h3>
                                    <div className="checkbox-grid-two-col">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="dsfa_durchgefuehrt"
                                                checked={formData.dsfa_durchgefuehrt}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                DSFA durchgeführt
                                                <small>DSGVO Art. 35</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="toms_dokumentiert"
                                                checked={formData.toms_dokumentiert}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                TOMs dokumentiert
                                                <small>DSGVO Art. 32</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="avv_vorhanden"
                                                checked={formData.avv_vorhanden}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                AVV vorhanden
                                                <small>DSGVO Art. 28</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="loeschkonzept_vorhanden"
                                                checked={formData.loeschkonzept_vorhanden}
                                                onChange={handleChange}
                                            />
                                            <span className="checkbox-text">
                                                Löschkonzept vorhanden
                                                <small>DSGVO Art. 17, Art. 5 Abs. 1 lit. e</small>
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div className="info-box">
                                    <strong>ℹ️ Hinweis:</strong> Diese Felder werden für die automatische GAP-Analyse verwendet.
                                    Fehlende Maßnahmen bei kritischen Anwendungen führen automatisch zur Erstellung von Compliance-GAPs.
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button type="button" onClick={onClose} className="btn-secondary">
                            Abbrechen
                        </button>
                        <button type="submit" className="btn-primary">
                            {anwendung ? 'Aktualisieren' : 'Erstellen'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AnwendungModal;